import { createContext } from "react";

export const RolesContext = createContext()
export const RolesFormContext = createContext()
export const RolesReportContext = createContext()